var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "rule"
  }, [_c('div', {
    staticClass: "content-wrap"
  }, [_c('h2', {
    staticClass: "label"
  }, [_vm._v("积分规则")]), _c('p', {
    staticClass: "label-title"
  }, [_vm._v("什么是积分")]), _c('p', {
    staticClass: "label-item"
  }, [_vm._v("积分是用户账户通过消费购物获得的奖励，消费购物越多，所获得的积分就越多，积分可用于抵扣部分商品金额。")]), _c('p', {
    staticClass: "label-title"
  }, [_vm._v("积分发放规则")]), _c('p', {
    staticClass: "label-item"
  }, [_vm._v("按当天单笔订单的消费额或当天成交总笔数计算积分奖励数，买家确认收货后即可获得积分。")]), _c('p', {
    staticClass: "label-title"
  }, [_vm._v("说明")]), _c('p', {
    staticClass: "label-item"
  }, [_vm._v("1、积分可以在参与积分抵现、积分兑换的商品使用。")]), _c('p', {
    staticClass: "label-item"
  }, [_vm._v("2、若发起售后，仅退款、退货退款成功后，需扣除交易中获得积分。")]), _c('p', {
    staticClass: "label-item"
  }, [_vm._v("3、支持送积分的商品可在商品的详情页查看。")]), _c('p', {
    staticClass: "label-item"
  }, [_vm._v("4、积分仅可在驰腾商城使用，用户账户若存在恶意下单等行为，驰腾官方有权取消该用户账户内的积分相关使用权益。")])])]);
}];
export { render, staticRenderFns };